// product-broker via Member Compliance frequently times out when sending products to
// cart, failing cart. There are multiple regex patterns because there are
// multiple scenarios:
// 1. Member Compliance itself times out but sends a valid response to the
// Cart service.
// 2. Member Compliance times out, timing out the Cart service as well.
// 3. Member compliance randomly loses connection to product-broker, timing out Cart service.
export const productBrokerTimeoutMessage =
  /(Member Compliance Error: (.*context deadline exceeded.*|.*timeout.*|.*map.err:invalid character))|prism.*failed/i
